import React from "react";
import { List } from "../modules/Contacts";

export function ContactsListPage () {
  return <List />;
}
